import { useLoaderData } from 'react-router-dom';
import { ITabState } from '../../../states/tabState.model';
import { FC } from 'react';
import { Bakery2bTable } from './components/bakery2bTable.component';

export const Bakery2b: FC = () => {
  const { bakery2bAccounts, bakery2bTabOptions, customerId } = useLoaderData() as ITabState;
  return (
    <Bakery2bTable
      {...{
        bakery2bData: bakery2bAccounts,
        bakery2bAccountsOptions: bakery2bTabOptions.bakery2bAccounts,
        customerId,
      }}
    />
  );
};
